import { useEffect, useRef, useState } from "react";
import { Formik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { DefaultLayout } from "../../../../layouts/Default";
import { Main } from "../../../../themes/Default/components/Main";
import { Tabs } from "../../../../themes/Default/components/Tabs";
import { TopNavigation } from "../../../../themes/Default/components/TopNavigation";
import { Breadcrumps } from "../../../../themes/Default/components/Breadcrumps";
import { Link } from "../../../../themes/Default/components/Breadcrumps/components/Link";
import { Button } from "../../../../themes/Default/components/TopNavigation/components/Button";
import { Form } from "../../../../themes/Default/components/Form";
import { Row } from "../../../../themes/Default/components/Form/components/Row";
import { Field } from "../../../../themes/Default/components/Form/components/Row/components/Field";
import { Input } from "../../../../themes/Default/components/Form/components/Input";
import { Textarea } from "../../../../themes/Default/components/Form/components/Textarea";
import { Select } from "../../../../themes/Default/components/Form/components/Select";
import { useTranslation } from "react-i18next";
import { prepareSelect } from "../../../../services/core/Select";
import { noteTypesManagement } from "../../../../hooks/api/NoteTypesManagement/NoteTypesManagement";
import { employeesManagement } from "../../../../hooks/api/EmployeesManagement";

const AddNote = () => {
    const { t } = useTranslation("common");
    const { employeeId } = useParams();
    const formRef = useRef(null);
    const navigate = useNavigate();
    const [formErrors, setFormErrors] = useState([]);
    const [noteTypes, setNoteTypes] = useState([]);
    const { useAddNoteMutation } = employeesManagement;
    const [addNote, { isLoading: isAddingNote }] = useAddNoteMutation();
    const { useNoteTypesListMutation } = noteTypesManagement;
    const [noteTypesList] = useNoteTypesListMutation();

    const tabs = [
        { title: t("details"), link: "/settings/reports", onClick: () => gotoDetailsTab(employeeId) },
        { title: t("documents"), link: "/settings/reports", onClick: () => gotoDocumentsTab(employeeId) },
        { title: t("notes"), link: "/settings/reports", isActive: true },
    ];

    const gotoDetailsTab = (employeeId) => {
        navigate("/employees/edit/" + employeeId);
    };

    const gotoDocumentsTab = (employeeId) => {
        navigate("/employees/" + employeeId + "/documents");
    };

    const onSave = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const onSaved = (values) => {
        addNote({ body: values, employeeId }).then((result) => {
            if (result?.error) {
                setFormErrors(result?.error?.data?.error?.violations);
            } else {
                navigate(`/employees/${employeeId}/notes`);
            }
        });
    };

    useEffect(() => {
        noteTypesList().then((result) => {
            let options = [];
            result?.data?.records.map((note) => {
                options.push({
                    id: note.id,
                    name: note.name,
                });
            });
            setNoteTypes(prepareSelect(options));
        });
    }, [noteTypesList]);

    return (
        <DefaultLayout>
            <TopNavigation>
                <Button title={t("save")} isDisabled={isAddingNote} icon="fa-regular fa-floppy-disk" onClick={onSave}></Button>
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Breadcrumps>
                    <Link title={t("employees.title")} icon="fa-user-tie" />
                    <Link title={t("notes")} />
                    <Link title={t("details")} />
                    <Link title="Add Note" isActive={true} />
                </Breadcrumps>
                <Formik
                    innerRef={formRef}
                    initialValues={{
                        type: "",
                        title: "",
                        description: "",
                    }}
                    onSubmit={onSaved}
                >
                    {({ values, handleChange }) => (
                        <Form>
                            <Row>
                                <Field>
                                    <Select
                                        name="type"
                                        label="Type"
                                        options={noteTypes}
                                        onChange={handleChange}
                                        selectedValue={values.type}
                                        error={formErrors?.type}
                                        required={true}
                                    />
                                </Field>
                                <Field>
                                    <Input name="title" label="Title" value={values.title} onChange={handleChange} error={formErrors?.title} />
                                </Field>
                            </Row>
                            <Row>
                                <Field isFullWidth={true}>
                                    <Textarea
                                        rows="7"
                                        name="description"
                                        label="Description"
                                        value={values.description}
                                        onChange={handleChange}
                                        error={formErrors?.description}
                                    />
                                </Field>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </Main>
        </DefaultLayout>
    );
};

export default AddNote;
